module.exports = __webpack_public_path__ + "img/Minie.160ed41f.jpg";